export const lessonplanOverviewBullets = [
  {
    name: "Lesson content",
    description:
      "Under the lesson overview, you'll see ACS codes, lesson objectives, evidence of learning, and example learning sequences.",
  },
  {
    name: "Download lesson plans",
    description: `You may notice an orange text box titled "Download Lesson Plan". By clicking this, you'll download a PDF covering purpose, module, outline, Australian curriculum content descriptions, and other helpful material.`,
  },
  {
    name: "Access the Knowledge Bank",
    description:
      "To access the Knowledge Bank, click on any one of the coloured links in the right side menu. If you do this, you'll see a drop down menu with links to materials designed to aid your teaching on this particular lesson. You can choose an overview or a variety of subtopics. You can also access the Knowledge Bank at any time using the link on the main website navigation.",
  },
];



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitHowTo/components/Sections/LessonPlanOverview/TTHTLessonPlanOverviewSection.consts.js